<template>
    <div>
        <img class="loading-image" src="@/assets/images/placeholders/UL-Loading-4B.gif" />
        Authenticating User
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'OidcCallback',
        methods: {
            ...mapActions('oidcStore', [
                'oidcSignInCallback'
            ])
        },
        created() {
            this.oidcSignInCallback()
                .then((redirectPath) => {
                    this.$router.push(redirectPath)
                })
                .catch((err) => {
                    console.error(err)
                    this.$router.push('/signin-oidc-error') // Handle errors any way you want
                });
        }
    }
</script>

<style scoped>
    div {
        text-align:center;
    }

    .loading-image {
        height: 2em;
        width: 2em;
    }
</style>
